import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import TranscriptBlockContainer from '@layout/TranscriptBlockContainer';
import messages from './messages';

export default class Disclaimer extends PureComponent {
  render() {
    return (
      <TranscriptBlockContainer.MainContainer>
        <TranscriptBlockContainer.H2>
          <FormattedMessage {...messages.title} />
        </TranscriptBlockContainer.H2>
        <p>
          <FormattedMessage {...messages.content} />
        </p>
      </TranscriptBlockContainer.MainContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./components/molecules/Disclaimer/Disclaimer.js